/*
 * @Author: Teemo Ding
 * @Date: 2021-08-04 16:14:27
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-07 11:20:26
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/index.tsx
 */

import { Skeleton } from '@/src/components/Antd';
import CommonHeader from '@/src/components/CommonHeader';
import {
  request_customerDetailList,
  request_saveRemarkTag,
  request_saveSubscriberDetail,
  request_subscriberDetailList,
} from '@/src/request/customer/customerDetail';
import { getParameter } from '@/src/tools/helper';
import { Form } from 'antd';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { i18nGet, handleOnGetStoreTimezoneUTC } from 'src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import AccountInviteModal from '../Components/AccountInviteModal';
import ActivitiesTimeline from './ActivitiesTimeline';
import CustomerAccount from './CustomerAccount';
import CustomerPrivacy from './CustomerPrivacy';
import LegalConsent from './LegalConsent';
import Orders from './Orders';
import RecipientAddressBook from './RecipientAddressBook';
import RemarksTags from './RemarksTags';
import Subscriber from './Subscriber';
import SubscriberInformation from './SubscriberInformation';
import Subscription from './Subscription';
import ThirdPartyLoginAccount from './ThirdPartyLoginAccount';
import { breadcrumbData } from './config';
import css from './css.module.less';
const permissions = () => {
  const edit_customer_info = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Customers,
        subCategory: EnumSubCategory.CustomerDetailsPage,
        operation: EnumOperation.edit_customer_info,
      }),
    ],
  });
  return {
    edit_customer_info,
  };
};

enum Section {
  All = 'All',
  TimeLine = 'TimeLine',
  Information = 'Information',
  Invite = 'Invite',
  Subscription = 'Subscription',
}
const CustomerDetails = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const timezoneInUTC = handleOnGetStoreTimezoneUTC();
  const { edit_customer_info } = permissions();
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent },
  } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const [hasModified, setHasModified] = useState(false);
  const [formData, setFormData] = useState();
  const [timeLineData, setTimeLineData] = useState([]);
  const [information, setInformation] = useState([]);
  const [lastInvitation, setLastInvitation] = useState();
  const [subscription, setSubscription] = useState([]);
  const parameterType = getParameter('type');
  const params: any = useParams();
  const { customerDatabaseUuid, customerUuid } = params;

  //初始化数据
  useEffect(() => {
    if (!loading) {
      setLoading(true);
    }
    initPageData([Section.All]);
    setHasModified(false);
  }, [customerUuid]);

  //页面分块重新渲染
  const initPageData = (type: Section[]) => {
    if (parameterType == 'Subscriber') {
      request_subscriberDetailList(customerUuid).then((response) => {
        if (type.includes(Section.All)) {
          setFormData(response);
          setTimeLineData(response.activities);
          setInformation(response.fields);
        }
        if (type.includes(Section.TimeLine)) {
          setTimeLineData(response.activities);
        }
        if (type.includes(Section.Information)) {
          setInformation(response.fields);
        }

        setLoading(false);
      });
    } else {
      request_customerDetailList(customerUuid).then((response) => {
        if (type.includes(Section.All)) {
          setFormData(response);
          setTimeLineData(response.customerActivies);
          setInformation(response.customerInfoFields);
          setLastInvitation(response.lastInvitation);
          setSubscription(response.subscription);
        }
        if (type.includes(Section.TimeLine)) {
          setTimeLineData(response.customerActivies);
        }
        if (type.includes(Section.Information)) {
          setInformation(response.customerInfoFields);
        }
        if (type.includes(Section.Invite)) {
          setLastInvitation(response.lastInvitation);
        }
        if (type.includes(Section.Subscription)) {
          setSubscription(response.subscription);
        }
        setLoading(false);
      });
    }
  };

  const history = useHistory();
  const onGoBackClick = () => {
    history.push(`/customerDatabase/customerList/${customerDatabaseUuid}`);
  };

  const onValuesChange = () => {
    if (!hasModified) {
      setHasModified(!hasModified);
    }
  };

  const onFinish = (values) => {
    values.uuid = customerUuid;
    if (parameterType == 'Subscriber') {
      values.storeUuid = _.get(formData, 'storeUuid', '');
      values.salesChannelUuid = _.get(formData, 'salesChannelUuid', '');
      values.customerUuid = _.get(formData, 'customerUuid', '');
      request_saveSubscriberDetail(values).then(() => {
        console.log('success');
        initPageData([Section.TimeLine]);
        setHasModified(false);
      });
    } else {
      values.customerUuid = customerUuid;
      request_saveRemarkTag(values).then(() => {
        console.log('success');
        initPageData([Section.TimeLine]);
        setHasModified(false);
      });
    }
  };

  const sendAccountInvite = () => {
    setShowModal(true);
    setModalTitle(getI18n('customerList.customerDetail.sendAccountInvite'));
    setModalContent(
      <AccountInviteModal
        information={information}
        onCancel={() => setShowModal(false)}
        reloadData={initPageData}
      />,
    );
  };

  const {
    uuid = '',
    registeredDate = '',
    registeredSalesChannelName,
    createdDate,
    remark = '',
    legalConsent = {},
    customer,
    customerDBName,
    // customerDatabaseName = '',
    customerDBUuid = '',
    availManualTags = [],
    appliedAutoTags = [],
    remarks,
    appliedManualTags,
    orderActivities = [],
    totalOrderAmount = '',
    numOfOrders = '',
    lastOrderAmount = '',
    averageOrderAmount = '',
    currencyCode = '',
    addressBooks,
    thirdPartyLoginAccounts,
    customerDatabase,
    customerTacList,
    consentAttributes,
    salesChannel,
    createdBy,
    timezoneInGmt,
    fullNameAutoPopulate,
  } = formData || ({} as any);

  const appliedManualTagsFilter = (appliedManualTags || []).map(
    (item) => item.uuid,
  );

  const haveEmail = information.filter(
    (item) => _.get(item, 'field.fieldType', '') === 'Email',
  );
  return (
    <div className={css.customerList}>
      <Skeleton loading={loading} active>
        <Form
          name={'languageSetting'}
          form={form}
          onFinish={onFinish}
          initialValues={{
            remark,
            tagUuids: appliedManualTagsFilter || [],
            remarks,
          }}
          onValuesChange={onValuesChange}
          className={css.editForm}>
          <CommonHeader
            breadcrumbData={breadcrumbData(
              parameterType,
              customerDBUuid || _.get(customerDatabase, 'uuid', ''),
              customerDBName || _.get(customerDatabase, 'name', ''),
              { getI18n },
            )}
            onSaveDisable={!hasModified || !edit_customer_info}
            onSubmit={() => form.submit()}
            onDiscard={onGoBackClick}
            onGoBackClick={onGoBackClick}
          />
          <div className={css.itemContain}>
            <Subscriber
              type={parameterType}
              registeredDate={registeredDate}
              salesChannel={salesChannel}
              createdBy={createdBy}
              timezoneInGMT={timezoneInGmt || timezoneInUTC}
              salesChannelName={
                _.get(salesChannel, 'name') || registeredSalesChannelName
              }
              createdDate={createdDate}
              uuid={uuid}
              sendAccountInvite={sendAccountInvite}
              lastInvitation={lastInvitation}
            />
            {parameterType !== 'Subscriber' && (
              <Orders
                orderActivities={orderActivities}
                totalOrderAmount={totalOrderAmount}
                numOfOrders={numOfOrders}
                currencyCode={currencyCode}
                timezoneInGMT={timezoneInUTC}
                lastOrderAmount={lastOrderAmount}
                averageOrderAmount={averageOrderAmount}
              />
            )}
            <SubscriberInformation
              setShowModal={setShowModal}
              setModalTitle={setModalTitle}
              setModalContent={setModalContent}
              customerInfoFields={information}
              parameterType={parameterType}
              reloadData={initPageData}
              fullNameAutoPopulate={fullNameAutoPopulate}
            />
            {parameterType == 'Subscriber' && (
              <CustomerAccount
                customerDatabaseUuid={customerDatabaseUuid}
                customer={customer ? [customer] : []}
              />
            )}
            {parameterType !== 'Subscriber' && (
              <ThirdPartyLoginAccount
                thirdPartyLoginAccounts={thirdPartyLoginAccounts}
              />
            )}
            {parameterType !== 'Subscriber' && (
              <RecipientAddressBook
                addressBooks={addressBooks}
                fullNameAutoPopulate={fullNameAutoPopulate}
              />
            )}
            <RemarksTags
              type={parameterType}
              autoTags={appliedAutoTags}
              availManualTags={availManualTags}
            />
            {parameterType !== 'Subscriber' && (
              <Subscription
                subscription={subscription}
                setShowModal={setShowModal}
                setModalTitle={setModalTitle}
                setModalContent={setModalContent}
                reloadData={initPageData}
                timezoneInGMT={timezoneInUTC}
                haveEmail={haveEmail.length && haveEmail[0].value.length}
              />
            )}
            <LegalConsent
              timezoneInGMT={timezoneInUTC}
              consentAttributes={
                parameterType == 'Subscriber'
                  ? (legalConsent || {}).consentAttributes
                  : consentAttributes
              }
              termsConditions={
                parameterType == 'Subscriber'
                  ? (legalConsent || {}).termsConditions
                  : customerTacList
              }
            />
            <ActivitiesTimeline
              setShowModal={setShowModal}
              setModalTitle={setModalTitle}
              setModalContent={setModalContent}
              customerUuid={customerUuid}
              activities={timeLineData}
              reloadData={initPageData}
            />
            <CustomerPrivacy
              setShowModal={setShowModal}
              setModalTitle={setModalTitle}
              setModalContent={setModalContent}
              customerDatabaseUuid={customerDatabaseUuid}
            />
          </div>
        </Form>
      </Skeleton>
    </div>
  );
};

export default ModalHoc(CustomerDetails);
